module.exports = __webpack_public_path__ + "static/media/rundkolben_fragezeichen.2271ad10.jpg";